import Vue from 'vue';
import Router from 'vue-router';
import Layout from "../layout/index";
// import qiankunRouter from './qiankunRouter'
Vue.use(Router);
export var constantRouterMap = [{
  path: '/login',
  meta: {
    title: '登录',
    noCache: true
  },
  component: function component(resolve) {
    return require(['@/views/login'], resolve);
  },
  hidden: true
}, {
  path: '/404',
  component: function component(resolve) {
    return require(['@/views/features/404'], resolve);
  },
  hidden: true
}, {
  path: '/401',
  component: function component(resolve) {
    return require(['@/views/features/401'], resolve);
  },
  hidden: true
}, {
  path: '/redirect',
  component: Layout,
  hidden: true,
  children: [{
    path: '/redirect/:path*',
    component: function component(resolve) {
      return require(['@/views/features/redirect'], resolve);
    }
  }]
}, {
  name: 'userCenter',
  path: '/user',
  component: Layout,
  hidden: true,
  redirect: 'noredirect',
  children: [{
    path: 'center',
    component: function component(resolve) {
      return require(['@/views/system/user/center'], resolve);
    },
    name: '个人中心',
    meta: {
      title: '个人中心'
    }
  }]
}
// {
//     name: "组件管理",
//     path: "/components",
//     hidden: false,
//     redirect: "noredirect",
//     component: Layout,
//     alwaysShow: true,
//     meta: {
//         title: "组件管理",
//         icon: "theme",
//         noCache: true
//     },
//     children: [{
//         name: "Icons",
//         path: 'iconStore',
//         hidden: false,
//         component: (resolve) => require(['@/views/components/icons/index'], resolve),
//         meta: {
//             title: "图标库",
//             noCache: true
//         }
//     }]
// }
];
export default new Router({
  base: '/lock_platform/',
  mode: 'history',
  scrollBehavior: function scrollBehavior() {
    return {
      y: 0
    };
  },
  // routes: constantRouterMap.concat(qiankunRouter)
  routes: constantRouterMap
});